import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FarmacogeneticaLinks } from '../model/farmacoGeneticaLinks.entity';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FarmacogeneticaLinksService {

  constructor(private http: HttpClient) { }

  public getFarmacogeneticaLinks() {
    return this.http.get<FarmacogeneticaLinks[]>(environment.backendUrl+'/farmacogenetica');
  }
}
